// extracted by mini-css-extract-plugin
export default {"container":"favorite_container__1mMxr","icon":"favorite_icon__3kINO","label":"favorite_label__1oLsq"};